import { useContext, useEffect, useState } from "react"
import { Card, Col, Container, Image, Jumbotron, Modal, Row } from "react-bootstrap"
import { useHistory, useParams } from "react-router"
import Get from "../api/Get"
import { authContext } from "../context/AuthContext"
import {GET_APPOINTMENT_BY_ID} from '../api/Routes'
import moment from 'moment'
import CardCredit from "../components/CardCredit"
import iconRecheck from '../img/icons/recheck.svg'
import { Link } from "react-router-dom"
import { withTranslation } from "react-i18next"

function PagarServicio({t}){
    const { id } = useParams()
    const {auth} = useContext(authContext)
    const [patient, setPatient] = useState(null)
    const [cita, setCita] = useState(null)
    const [showSuccess, setShowSuccess] = useState(false);
    const [appointment, setAppointment]  = useState('')
    const history = useHistory()

    const handleCloseSuccess = () => setShowSuccess(false);
    
    useEffect(()=>{
        Get({url: `${GET_APPOINTMENT_BY_ID}/${id}`, access_token: auth.data.access_token})
        .then(response=>{
            setPatient(response.data.patientDTO)
            setCita(response.data.scheduleDTO)
            setAppointment(response.data.appointmentStatus)
        })
        .catch(error=>{
            console.log(error)
        })
    },[])


    return(
        <Container fluid className="my-5">
            <Row>
                <Col xs="12" md="12">
                    <h2 className="mb-0 title-top">{t('informacion_pago')}</h2>
                </Col>
            </Row>
            {
                appointment && appointment === "Pendiente" ?
                <Row className="mt-4">
                    <Col xs="12" md="6">
                        <Row>
                            <Col xs="12" md="12" className="mb-2">
                                <Card className="bg-info-1 text-white">
                                    <Card.Body>
                                        <div className="p-2">
                                            <h2>{t('total_pagar')}: $800 mxn</h2>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col xs="12" md="12">
                                <Card>
                                    <Card.Body>
                                        <div className="font-size-09rem color-6A6A">
                                            <label><strong className="text-dark">{t('nombre_completo')}: </strong>{patient && `${patient.name} ${patient.middleName ?? ''} ${patient.lastName} ${patient.seccondSurname ?? ''}`}</label>
                                        </div>
                                        <div className="font-size-09rem color-6A6A">
                                            <label><strong className="text-dark">{t('Correoelectronico')}: </strong>{patient && patient.email}</label>
                                        </div>
                                        <div className="font-size-09rem color-6A6A">
                                            <label><strong className="text-dark">{t('Telefono')}: </strong>{patient && patient.phone}</label>
                                        </div>

                                        <div className="my-2">
                                            <strong className="title-top-2">{t('horario')}</strong>
                                        </div>

                                        <div className="font-size-09rem color-6A6A">
                                            <label><strong className="text-dark">{t('fecha')}: </strong>{cita && `${moment(cita.date, "DD/MM/YYYY").format("dddd DD MMMM YYYY")} ${cita.hour} hrs`}</label>
                                        </div>
                                        <div className="font-size-09rem color-6A6A">
                                            <label><strong className="text-dark">{t('doctor')}: </strong>{cita && cita.name_doctor}</label>
                                        </div>
                                        <div className="font-size-09rem color-6A6A">
                                            <label><strong className="text-dark">{t('especialidad')}: </strong>{cita && cita.doctor.espcialityList[0].name}</label>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </Col>
                    <Col xs="12" md="6">
                        <CardCredit 
                            id={id} 
                            access_token={auth.data.access_token}
                            setShowSuccess={setShowSuccess}
                            history={history}
                        />
                    </Col>
                </Row> : appointment &&
                <Row className="mt-4">
                    <Col xs="12" md="12">
                        <Jumbotron>
                            <div className="text-center text-secondary">
                                <h2>{`Esta cita se encuentra ${appointment}`}</h2>
                                <Link to="/admin" className="btn btn-link">{t('crear_nueva_cita')}</Link>
                            </div>
                            
                        </Jumbotron>
                    </Col>
                </Row>
            }
            
            <Modal show={showSuccess} onHide={handleCloseSuccess} centered className="border-0">
                <Modal.Body className="p-0">
                    <div className="text-center position-relative overflow-hidden h-100p">
                        <Image src={iconRecheck} fluid className="img-recheck"/>
                        <h5 className="mb-0 text-app-success">{t('solicitud_exitosa')}</h5>
                    </div>                
                </Modal.Body>
            </Modal>
        </Container>
    )

}

export default withTranslation()(PagarServicio)